import SpotlightText from '@ancon/wildcat-ui/web/orderweb/SpotlightText'
import '@ancon/wildcat-ui/web/orderweb/SpotlightText/SpotlightText.css'

export default SpotlightText
